(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltOptionRestoreController', OltOptionRestoreController);

    OltOptionRestoreController.$inject = ['$scope', '$uibModalInstance', 'OltData', 'OltService'];

    function OltOptionRestoreController($scope, $uibModalInstance, OltData, OltService) {
        var vm = this;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.configDefault = function () {
            vm.close();
            var dataAction = {
                action: 'reset',
                confirmation: true,
                afterConfirmAction: 'confirmReset',
                methodService: 'resetOlt',
                methodExtra: function (oltList) {
                    OltData.removeOlts(oltList)
                }
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        vm.restoreConfig = function () {
            vm.close()
            //OltService.restoreModalConstructor();
            OltService.restoreBackupOltModalConstructor(OltData.detail.id);
        }
    }
})();